import type { BodyCreateTicketApiV1TicketsPost } from '@/shared/generated'
import type { UseMutationOptions } from '@tanstack/react-query'

import { useMutation } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export function useCreateSupportTicketMutation(
	options?: UseMutationOptions<any, Error, BodyCreateTicketApiV1TicketsPost>
) {
	return useMutation<any, Error, BodyCreateTicketApiV1TicketsPost>({
		mutationFn: async (body: BodyCreateTicketApiV1TicketsPost) =>
			await client.tickets.createTicket(body),
		...(options || {}),
	})
}
